import React, { useEffect, useState } from 'react';
import { IMenuItem } from 'types/sidebar';
import MenuItem from 'components/parts/menu-item';
import { MENU_SIDEBAR } from 'consts/menu-sidebar.const';
import { Role } from 'consts/common.const';
import { useSession } from 'hooks/use-session.hook';
import { userPermission } from 'services/user-permission';
import { getMasterData } from 'services/master-data';

interface Ilogo {
  logo: string;
  sologan: string;
}

export default function Sidebar({ isCheckCollapse, clientWidth }: { isCheckCollapse: boolean; clientWidth: number }) {
  const { userInfo } = useSession();
  const [logo, setLogo] = useState<Ilogo>();
  const [statusSidebar, setStatusSidebar] = useState<number>();
  const sidebarPermission = () => {
    const parseData = userPermission.getUserRight();

    return [
      'sidebar.menu.dashboard',
      'sidebar.menu.clear_cache',
      'sidebar.menu.doc',
      'sidebar.menu.kpi',
      'sidebar.menu.task',
      userPermission.canView('revenue_expenditure') && 'sidebar.menu.turnovers',
      (userInfo?.role === Role.ROOT || userInfo?.role === Role.ACCOUNTANT) && 'sidebar.menu.setting',
      ...Object.entries(parseData)
        .filter((item: any) => item[1].view === 1)
        .map((data) => 'sidebar.menu.' + data[0]),
    ];
  };

  useEffect(() => {
    getMasterData('getGeneral').subscribe((res) => {
      const data = {
        logo: res.data.find((item) => item.key === 'linkAvatar').value,
        sologan: res.data.find((item) => item.key === 'sologan').value,
      };

      setStatusSidebar(clientWidth >= 992 && Number(res.data.find((item) => item.key === 'status_slidebar').value));
      setLogo(data);
    });
  }, [clientWidth]);

  return (
    <aside className='main-sidebar sidebar-dark-info elevation-4 sidebar-no-expand'>
      {/* Brand Logo */}
      <a
        href='https://app.hirexmkt.online/inbox/all?channel=FACEBOOK'
        target='_blank'
        rel='noopener noreferrer'
        className='brand-link'
      >
        <img
          src={logo?.logo}
          alt='Logo'
          className='brand-image img-circle elevation-3'
          style={{
            opacity: '.8',
            maxWidth: '41px',
            maxHeight: '41px',
            objectFit: 'cover',
            filter: 'brightness(1.5)',
          }}
        />
        <div
          className='brand-text font-weight-light'
          style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}
        >
          {logo?.sologan}
        </div>
      </a>
      {/* Sidebar */}
      <div className='sidebar'>
        {/* Sidebar Menu */}
        <nav className='mt-2'>
          <ul
            className='nav nav-pills nav-sidebar flex-column'
            data-widget='treeview'
            role='menu'
            data-accordion='false'
          >
            {/* <MenuItem key={'432423423423'} menuItem={{ name: 'chat', path: '/chat' }} statusSidebar={1} /> */}
            {MENU_SIDEBAR.filter((item) => sidebarPermission().includes(item.name)).map((menuItem: IMenuItem) => (
              <MenuItem
                key={menuItem.name}
                menuItem={menuItem}
                statusSidebar={statusSidebar}
                isCheckCollapse={isCheckCollapse}
              />
            ))}
          </ul>
        </nav>
      </div>
    </aside>
  );
}
